import { useState } from 'react';

export const TABLE_PAGE_SIZE = 50;

/** Pagination page par page côté client : découpe `total` lignes en pages de `pageSize`. */
export function usePagination(total: number, pageSize = TABLE_PAGE_SIZE) {
  const [page, setPage] = useState(1);
  const pageCount = Math.max(1, Math.ceil(total / pageSize));
  const currentPage = Math.min(page, pageCount);
  const start = (currentPage - 1) * pageSize;
  const end = Math.min(start + pageSize, total);
  return { page: currentPage, pageCount, start, end, setPage };
}
